(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Hero slider
  document.querySelectorAll('[data-zslider]').forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll('[data-zslide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-zdot]'));
    if (slides.length < 2) return;
    var i = 0, timer = null;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.style.opacity = k === i ? '1' : '0';
        s.style.pointerEvents = k === i ? 'auto' : 'none';
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      dots.forEach(function (d, k) { d.style.background = k === i ? '#14301c' : '#ffffff'; });
    }
    function start() {
      clearInterval(timer);
      if (reduce) return;
      timer = setInterval(function () { show(i + 1); }, 4500);
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-zprev],[data-znext],[data-zdot]');
      if (!b) return;
      if (b.hasAttribute('data-zprev')) show(i - 1);
      else if (b.hasAttribute('data-znext')) show(i + 1);
      else show(parseInt(b.getAttribute('data-zdot'), 10) || 0);
      start();
    });
    show(0);
    start();
  });

  // Shop all menu
  var root = document.querySelector('[data-zmenu-root]');
  if (root) {
    var btn = root.querySelector('[data-zmenu-btn]');
    var panel = root.querySelector('[data-zmenu-panel]');
    if (btn && panel) {
      var set = function (open) {
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.style.background = open ? '#1f4d2b' : '#eef1e6';
        btn.style.color = open ? '#ffffff' : '#14301c';
      };
      var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
      btn.addEventListener('click', function () { set(panel.hidden); });
      if (canHover) {
        btn.addEventListener('mouseenter', function () { set(true); });
        root.addEventListener('mouseleave', function () { set(false); });
      }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
      document.addEventListener('click', function (e) { if (!root.contains(e.target)) set(false); });
      panel.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    }
  }
})();

/* Cart button, quantity stepper and side cart */
(function () {
  'use strict';
  var Z = window.zeel || {};
  var cartUrl = Z.cartUrl || '/cart';
  var css = document.querySelector('link[href*=\'zeel.css\']');
  var assetBase = css ? css.href.split('zeel.css')[0] : '';
  var BAG = '<svg aria-hidden=true width=20 height=20 viewBox=\'0 0 24 24\' fill=none stroke=currentColor stroke-width=1.9 stroke-linecap=round stroke-linejoin=round><path d=\'M5.5 8h13l-1.1 12.5H6.6L5.5 8Z\'/><path d=\'M9 8V7a3 3 0 0 1 6 0v1\'/></svg>';
  function money(c) { return 'Rs. ' + (c / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 }); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function pic(h) {
    var m = [['radiance', 'zeel-radiance.jpg'], ['hydrat', 'zeel-hydrate.jpg'], ['Marine', 'zeel-marine.jpg'], ['marine', 'zeel-marine.jpg'], ['ageing', 'zeel-ageing.jpg'], ['dreams', 'zeel-dreams.jpg'], ['belly', 'zeel-gut.jpg'], ['gut', 'zeel-gut.jpg'], ['crisps', 'zeel-crisps.jpg']];
    for (var i = 0; i < m.length; i++) if (h.indexOf(m[i][0]) > -1) return assetBase + m[i][1];
    return '';
  }

  // header cart button
  var link = document.querySelector('[data-zmenu-root] a[aria-label=Cart]');
  if (link) {
    var n = (link.querySelector('[data-cart-count]') || {}).textContent || '0';
    link.className = 'zcart-btn';
    link.removeAttribute('style');
    link.innerHTML = BAG + '<span class=zcart-label>Cart</span><span class=zcart-badge data-cart-count>' + esc(n) + '</span>';
  }

  // quantity stepper on the product page
  var q = document.getElementById('pdp-qty');
  if (q) {
    var wrap = document.createElement('div');
    wrap.className = 'zqty';
    q.parentNode.insertBefore(wrap, q);
    var minus = document.createElement('button'), plus = document.createElement('button');
    minus.type = plus.type = 'button';
    minus.textContent = '−'; plus.textContent = '+';
    minus.setAttribute('aria-label', 'Decrease quantity'); plus.setAttribute('aria-label', 'Increase quantity');
    q.removeAttribute('style'); q.type = 'text'; q.setAttribute('inputmode', 'numeric');
    wrap.appendChild(minus); wrap.appendChild(q); wrap.appendChild(plus);
    var val = function () { return Math.max(1, parseInt(q.value, 10) || 1); };
    minus.addEventListener('click', function () { q.value = Math.max(1, val() - 1); });
    plus.addEventListener('click', function () { q.value = val() + 1; });
    q.addEventListener('change', function () { q.value = val(); });
    var btn = wrap.parentNode.querySelector('button[type=submit]');
    var price = document.querySelector('[data-price]');
    if (btn) {
      btn.className = 'zeel-pop zadd';
      btn.removeAttribute('style');
      btn.innerHTML = BAG + '<span>Add to cart</span>' + (price ? '<span class=zadd-price>' + esc(price.textContent.trim()) + '</span>' : '');
    }
  }

  // side cart
  var back = document.createElement('div'); back.className = 'zdrawer-back'; back.hidden = true;
  var dr = document.createElement('aside'); dr.className = 'zdrawer'; dr.hidden = true;
  dr.setAttribute('role', 'dialog'); dr.setAttribute('aria-modal', 'true'); dr.setAttribute('aria-label', 'Your cart');
  document.body.appendChild(back); document.body.appendChild(dr);
  var lastFocus = null;
  function render(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var h = '<div class=zdrawer-head><strong>Your cart <span>(' + cart.item_count + ')</span></strong><button type=button data-zclose aria-label=\'Close cart\'>×</button></div>';
    if (!cart.items.length) {
      h += '<div class=zdrawer-empty><p>Your cart is empty.</p><a class=zdrawer-cta href=\'/collections/all\'>Shop the range</a></div>';
    } else {
      h += '<ul class=zdrawer-items>';
      cart.items.forEach(function (it, i) {
        var img = it.image || pic(it.handle || '');
        h += '<li><a class=zdrawer-img href=\'' + esc(it.url) + '\'>' + (img ? '<img alt=\'\' src=\'' + esc(img) + '\'>' : '') + '</a><div class=zdrawer-info><a href=\'' + esc(it.url) + '\'>' + esc(it.product_title) + '</a>'
          + (it.variant_title ? '<small>' + esc(it.variant_title) + '</small>' : '')
          + '<div class=zdrawer-row><div class=zqty><button type=button data-zline=' + (i + 1) + ' data-zq=' + (it.quantity - 1) + ' aria-label=\'Decrease quantity\'>−</button><span>' + it.quantity + '</span><button type=button data-zline=' + (i + 1) + ' data-zq=' + (it.quantity + 1) + ' aria-label=\'Increase quantity\'>+</button></div><b>' + money(it.final_line_price) + '</b></div>'
          + '<button type=button class=zdrawer-remove data-zline=' + (i + 1) + ' data-zq=0>Remove</button></div></li>';
      });
      h += '</ul><div class=zdrawer-foot><div class=zdrawer-sub><span>Subtotal</span><b>' + money(cart.total_price) + '</b></div><small>Shipping and taxes are calculated at checkout.</small><a class=zdrawer-cta href=\'/checkout\'>Checkout</a><a class=zdrawer-view href=\'' + esc(cartUrl) + '\'>View full cart</a></div>';
    }
    dr.innerHTML = h;
  }
  function load() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }
  function open() {
    lastFocus = document.activeElement;
    load().then(function () {
      back.hidden = false; dr.hidden = false;
      requestAnimationFrame(function () { back.classList.add('is-open'); dr.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      var c = dr.querySelector('[data-zclose]'); if (c) c.focus();
    });
  }
  function close() {
    back.classList.remove('is-open'); dr.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { back.hidden = true; dr.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  back.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dr.hidden) close(); });
  dr.addEventListener('click', function (e) {
    if (e.target.closest('[data-zclose]')) return close();
    var b = e.target.closest('[data-zline]');
    if (!b) return;
    b.disabled = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: parseInt(b.getAttribute('data-zline'), 10), quantity: parseInt(b.getAttribute('data-zq'), 10) }) })
      .then(function (r) { return r.json(); }).then(render).catch(load);
  });
  if (link && location.pathname !== cartUrl) link.addEventListener('click', function (e) { e.preventDefault(); open(); });

  // add to cart: open the side cart instead of showing a toast
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = form.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    fetch((Z.cartAddUrl || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart'); }); })
      .then(open)
      .catch(function (err) { var t = document.getElementById('toast'); if (t) { t.textContent = err.message; t.hidden = false; setTimeout(function () { t.hidden = true; }, 4000); } })
      .then(function () { if (btn) btn.disabled = false; });
  }, true);
})();
